import {BaseContainerModel} from '../../base-container.model';
import {bl_cms_website_country_hdr_RowClass} from '../../../dbschema';
import {bl_cms_website_country_ext_RowClass} from '../../../dbschema'

export class WebsiteCountryContainerModel extends BaseContainerModel {
  bl_cms_website_country_hdr: bl_cms_website_country_hdr_RowClass = new bl_cms_website_country_hdr_RowClass();
  bl_cms_website_country_exts: bl_cms_website_country_ext_RowClass [] = [];
}
